import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Heading from 'components/shared/heading';
import Item from './item';

import styles from './faq.module.scss';

const cx = classNames.bind(styles);

const renderItems = (items, sideNumber) =>
  items.map(({ title, description }, index) => {
    const id = `faq-item-${sideNumber}-${index + 1}`;
    return <Item id={id} title={title} description={description} key={index} />;
  });

const FAQ = ({ title, items }) => {
  const firstSideItems = items.slice(0, Math.ceil(items.length / 2));
  const secondSideItems = items.slice(Math.ceil(items.length / 2));

  return (
    <section className={cx('wrapper')}>
      <div className={cx('container', 'inner')}>
        <Heading className={cx('title')} tag="h2" size="xxl">
          {title}
        </Heading>
        <div className={cx('items-wrapper')}>
          <dl className={cx('items-side')}>{renderItems(firstSideItems, 1)}</dl>
          <dl className={cx('items-side')}>{renderItems(secondSideItems, 2)}</dl>
        </div>
      </div>
    </section>
  );
};

FAQ.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default FAQ;
